import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { RootState } from "../../../reducers";
import { hasAnyRole, superAdminRolesForEnv } from "@ink-ai/portal/common/authHelper";

type RequireSuperAdminProps = {
    children: React.ReactNode;
    redirectTo?: string;
};

const RequireSuperAdmin: React.FC<RequireSuperAdminProps> = ({ children, redirectTo = '/no-permission' }) => {
    const location = useLocation();
    const authState = useSelector((state: RootState) => state.auth);

    // If no group info in token, skip group check (Cognito or groups not configured)
    if (!authState.group) {
        return <>{children}</>;
    }

    const isSuperAdmin = hasAnyRole(authState.group, superAdminRolesForEnv());
    if (!isSuperAdmin) {
        return <Navigate to={redirectTo} state={{ from: location }} replace />
    }

    return <>{children}</>
}

export default RequireSuperAdmin;
